import cauliflowerIcon from "../assets/icons/cauliflower.png";
import squashIcon from "../assets/icons/squash.png";

const customIcons: Record<string, string> = {
  "img:cauliflower": cauliflowerIcon,
  "img:squash": squashIcon,
};

interface CategoryIconProps {
  icon: string;
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
}

export function CategoryIcon({ icon, className = "", size = "md" }: CategoryIconProps) {
  const sizeClasses = {
    sm: "text-base w-4 h-4",
    md: "text-xl w-5 h-5",
    lg: "text-2xl w-6 h-6",
    xl: "text-3xl w-8 h-8",
  };

  const imgSizes = {
    sm: "w-4 h-4",
    md: "w-5 h-5",
    lg: "w-6 h-6",
    xl: "w-8 h-8",
  };

  if (icon.startsWith("img:")) {
    const imgSrc = customIcons[icon];
    if (imgSrc) {
      return (
        <img 
          src={imgSrc} 
          alt="category icon" 
          className={`${imgSizes[size]} object-contain inline-block ${className}`}
        />
      );
    }
    // Fallback for unknown custom icons - show a placeholder
    return <span className={`${sizeClasses[size]} ${className}`}>📦</span>;
  }

  return <span className={`${sizeClasses[size]} ${className}`}>{icon}</span>;
}

export function getCategoryIconOptions() {
  return [
    { value: "🍎", label: "Apple" },
    { value: "🥑", label: "Avocado" },
    { value: "🍌", label: "Banana" },
    { value: "🫜", label: "Beet/Turnip" },
    { value: "🫑", label: "Bell Pepper" },
    { value: "🫐", label: "Blueberry" },
    { value: "🍞", label: "Bread" },
    { value: "🥦", label: "Broccoli" },
    { value: "img:cauliflower", label: "Cauliflower", isImage: true },
    { value: "🥕", label: "Carrot" },
    { value: "🌰", label: "Chestnut" },
    { value: "🍒", label: "Cherry" },
    { value: "🧀", label: "Cheese" },
    { value: "🥥", label: "Coconut" },
    { value: "🌽", label: "Corn" },
    { value: "🥒", label: "Cucumber" },
    { value: "🍆", label: "Eggplant" },
    { value: "🥚", label: "Egg" },
    { value: "🐟", label: "Fish" },
    { value: "🌸", label: "Flowers" },
    { value: "🧄", label: "Garlic" },
    { value: "🍇", label: "Grapes" },
    { value: "🌿", label: "Herbs" },
    { value: "🌶️", label: "Hot Pepper" },
    { value: "🧃", label: "Juice" },
    { value: "🥝", label: "Kiwi" },
    { value: "🥬", label: "Leafy Green" },
    { value: "🍋", label: "Lemon" },
    { value: "🥛", label: "Milk" },
    { value: "🍈", label: "Melon" },
    { value: "🥩", label: "Meat" },
    { value: "🥭", label: "Mango" },
    { value: "🍄", label: "Mushroom" },
    { value: "🧅", label: "Onion" },
    { value: "🍊", label: "Orange" },
    { value: "📦", label: "Other" },
    { value: "🥫", label: "Packaged Foods" },
    { value: "🥜", label: "Peanut" },
    { value: "🍐", label: "Pear" },
    { value: "🍑", label: "Peach" },
    { value: "🍍", label: "Pineapple" },
    { value: "🍗", label: "Poultry" },
    { value: "🍳", label: "Prepared" },
    { value: "🥔", label: "Potato" },
    { value: "🥗", label: "Salad" },
    { value: "🦐", label: "Shrimp" },
    { value: "img:squash", label: "Squash", isImage: true },
    { value: "🍓", label: "Strawberry" },
    { value: "🍅", label: "Tomato" },
    { value: "🍉", label: "Watermelon" },
  ];
}

export { customIcons };
